/* tslint:disable */
/* eslint-disable */
/**
 * Auth API
 * This is an OpenAPI for the Auth Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CheckTokenRequest } from '../models';
import { CheckTokenResponse } from '../models';
import { GetAccessTokenResponse } from '../models';
/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks if the token exists in the DB. If it doesn't then the user token has expired and been deleted or the token given does not correspond to the correct user. If found, returns the allowed microservices object.
         * @summary Checks if the token exists in the DB and returns the allowed microservices object.
         * @param {CheckTokenRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkToken: async (body?: CheckTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Token/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new Access token from the refresh token provided
         * @summary Get Access Token from refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Token/GetAccessToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication RefreshKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Refresh-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Refresh-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Checks if the token exists in the DB. If it doesn't then the user token has expired and been deleted or the token given does not correspond to the correct user. If found, returns the allowed microservices object.
         * @summary Checks if the token exists in the DB and returns the allowed microservices object.
         * @param {CheckTokenRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkToken(body?: CheckTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<CheckTokenResponse>>> {
            const localVarAxiosArgs = await TokenApiAxiosParamCreator(configuration).checkToken(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create new Access token from the refresh token provided
         * @summary Get Access Token from refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetAccessTokenResponse>>> {
            const localVarAxiosArgs = await TokenApiAxiosParamCreator(configuration).getAccessToken(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Checks if the token exists in the DB. If it doesn't then the user token has expired and been deleted or the token given does not correspond to the correct user. If found, returns the allowed microservices object.
         * @summary Checks if the token exists in the DB and returns the allowed microservices object.
         * @param {CheckTokenRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkToken(body?: CheckTokenRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<CheckTokenResponse>> {
            return TokenApiFp(configuration).checkToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new Access token from the refresh token provided
         * @summary Get Access Token from refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessToken(options?: AxiosRequestConfig): Promise<AxiosResponse<GetAccessTokenResponse>> {
            return TokenApiFp(configuration).getAccessToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI {
    /**
     * Checks if the token exists in the DB. If it doesn't then the user token has expired and been deleted or the token given does not correspond to the correct user. If found, returns the allowed microservices object.
     * @summary Checks if the token exists in the DB and returns the allowed microservices object.
     * @param {CheckTokenRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public async checkToken(body?: CheckTokenRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<CheckTokenResponse>> {
        return TokenApiFp(this.configuration).checkToken(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new Access token from the refresh token provided
     * @summary Get Access Token from refresh token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public async getAccessToken(options?: AxiosRequestConfig) : Promise<AxiosResponse<GetAccessTokenResponse>> {
        return TokenApiFp(this.configuration).getAccessToken(options).then((request) => request(this.axios, this.basePath));
    }
}